import { cn } from "@/utils/helpers";

/** Shared trigger surface — control glass capsule (style B). */
export const kitDropdownTriggerClass = "co-dropdown-trigger";

/** Shared floating panel — uses .co-dropdown-panel for the shared glass panel material. */
export const kitDropdownPanelClass = "co-dropdown-panel";

/** Shared list-item surface for custom popover menus (OrgPicker, BrandPicker, etc.). */
export const kitDropdownMenuItemClass = cn(
  "flex min-h-9 w-full items-center justify-between gap-2.5 px-2.5 py-2 text-left text-[13px] font-medium",
  "text-co-muted transition-colors rounded-row hover:bg-co-hover hover:text-co-text",
);

export const kitDropdownMenuItemActiveClass = "bg-co-accent-dim text-co-text";
